import type { Maybe } from '@adornis/base/utilTypes.js';
import { Float, Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';

/**
 * The summary of one import run, shown on the admin dashboard. One document per run; the state of the single
 * files lives in {@link AccountingImportFile}.
 */
@Entity()
export class TaxAdvisorImportInformation extends MongoEntity {
  public static override _class = 'TaxAdvisorImportInformation';
  public static override _collectionName = 'tax-advisor-import-information';

  @Field(() => Date, { default: v => v ?? new Date() })
  createdAt!: Date;

  @validate(nonOptional({ allowFalsy: true }))
  @Field(() => Int)
  numberOfImportedEntries: Maybe<number>;

  @Field(() => Float)
  secondsTaken: Maybe<number>;

  @Field(() => Int)
  totalAmount: Maybe<number>;
}
